<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        ><i class="fa fa-plus"></i> Inserir
                                        Documento</b-button
                                    >
                                    <b-button
                                        variant="warning"
                                        @click.stop="$emit('fechar')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <pagamento-anexo-download
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                ></pagamento-anexo-download>
                                <pagamento-anexo-excluir
                                    :pagamento="pagamento"
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                    @obterPagamentoAtualizado="
                                        obterPagamentoAtualizado()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></pagamento-anexo-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <pagamento-anexo-form
            ref="pagamentoAnexoForm"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            :mostrarCampoNumeroDocumento="false"
        ></pagamento-anexo-form>
    </div>
</template>

<script>
import PagamentoAnexoDownload from './PagamentoAnexoDownload'
import PagamentoAnexoForm from './PagamentoAnexoForm'
import PagamentoAnexoExcluir from './PagamentoAnexoExcluir'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            anexos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'anexoTipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterAnexos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterAnexos(this.$route.params.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.anexos = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter os documentos.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirAnexo() {
            this.$refs.pagamentoAnexoForm.mostrarModal = true
        },

        obterPagamentoAtualizado() {
            this.obterAnexos()
        }
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return this.$temAcesso('SGTEC-PAG-ANX-01')
        },

        mostrarBtnExcluirAnexo() {
            return this.$temAcesso('SGTEC-PAG-ANX-02')
        }
    },

    created() {
        this.obterAnexos()
    },

    components: {
        PagamentoAnexoForm,
        PagamentoAnexoDownload,
        PagamentoAnexoExcluir
    }
}
</script>
